/* eslint-disable @typescript-eslint/no-explicit-any */
export enum ClientTypeSR {
    Customer = 'Kupac',
    Service = 'Servis',
    Supplier = 'Dobavljac',
}
